import type { FaireProductEntity } from "../../entity_types/product";

export const p_sr4bnba723: FaireProductEntity = {
  token: "p_sr4bnba723",
  type: "product",
  name: "Triple Trees - Custom - Toddler Short Sleeve Crew Tee",
  brandToken: "b_1bd10jxt4j",
  brandName: "MT Brand Apparel",
  imageUrl: "https://cdn.faire.com/fastly/7c41c8a9d81e7ee0b8f2de61e92f2ea57509c996a0a5ce8b002657d345582f56.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c7d27bfedf3a66a3b6db184141648f7ac0ed793f043800474f1b889b42368fa2.png",
    "https://cdn.faire.com/fastly/129dcf936699ac01aca89b5137e69772e60947a862066bc8f9e25c9f6b116013.png",
    "https://cdn.faire.com/fastly/21de8256be59e09b3d0ee2fb6c0a84b4bf4839d8aa7b525c5125b07a3575afd5.png"
  ],
  priceDollars: 10,
  description: "Customize for your location on this cute toddler tee. We will replace Colorado, Vermont, Michigan and Montana with your location.\nToddler tee are available in sizes 2T, 3T, 4T and 5/6 and made from 100% cotton.\n\nThis cute tee is offered in four fun colors.\n\nMT Brand Apparel prints and ships from Stevensville, Montana.",
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-09T08:03:47.482Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
